import {
	Component,
	EventEmitter,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { LanguageDataProvider } from '@services/language/language.data.service';
import { Subject } from 'rxjs/Subject';
import { finalize, takeUntil } from 'rxjs/operators';
import { NavBreadcrumb } from '@models/models';
import { SettingsProvider } from '@services/settings/settings';
import {
	LabelItem,
	LabelsData,
	SettingsBrandLabelsData
} from '@models/brands.model';

@Component({
	selector: 'customize-labels',
	template: require('./customize-labels.html'),
	styles: [require('./customize-labels.scss')]
})
export class CustomizeLabelsComponent implements OnInit, OnDestroy {
	@Output() onLabelsDataChange: EventEmitter<void> = new EventEmitter();

	disabledButtons: Array<boolean> = [];
	unsubscribe: Subject<void> = new Subject<void>();
	initialData: Array<LabelsData> = [];
	languageData: Array<LabelsData> = [];

	breadcrumbs: Array<NavBreadcrumb> = [
		{ link: '/', title: 'Dashboard' },
		{ link: '/settings', title: 'Settings' },
		{ link: null, title: 'Labels' }
	];
	constructor(
		private settingsService: SettingsProvider,
		private messageService: MessageService,
		private languageService: LanguageDataProvider
	) {}

	ngOnInit(): void {
		this.languageService
			.getLabels()
			.subscribe((data: SettingsBrandLabelsData) => {
				this.languageData = data.data;
				this.initialData = JSON.parse(JSON.stringify(this.languageData));
				this.disabledButtons = new Array(this.languageData.length).fill(false);
			});
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	saveData(index: number): void {
		const {
			language: { name = '' } = {},
			customLabels = [],
			actions: {
				SAVE_LABELS: { url }
			}
		} = this.languageData[index];

		const dataToSave = {
			language: name,
			customLabelsData: customLabels.map(({ fieldName, value }) => ({
				fieldName,
				value
			}))
		};

		if (this.isDataValid(dataToSave.customLabelsData)) {
			this.disabledButtons[index] = true;

			this.languageService
				.updateLabels(url, dataToSave)
				.pipe(
					takeUntil(this.unsubscribe),
					finalize((): boolean => (this.disabledButtons[index] = false))
				)
				.subscribe(
					() => this.successDataChange(dataToSave),
					(): void => this.messageService.showToaster('e_0', 'general')
				);
		}
	}

	private successDataChange({ language, customLabelsData }): void {
		// probably will be deleted/changed later
		if (language === 'ENGLISH') {
			const setLangs = customLabelsData.reduce(
				(acc, curr) => ({ ...acc, [curr.fieldName]: curr.value }),
				{}
			);
			this.settingsService.setCustomizeLabels(setLangs);
		}
		this.onLabelsDataChange.emit();
		this.messageService.showToaster('s_0', 'customizeLabels');
	}

	private isDataValid(fields: Array<LabelItem>): boolean {
		let spaceError = false;
		const inValid = fields.some(el => {
			if (el.fieldName === 'shootsLabel') {
				if (/\s/.test(el.value)) {
					spaceError = true;
				}
			}
			return !el.value || !el.value.trim();
		});

		if (inValid) {
			this.messageService.showToaster('e_0', 'customizeLabels');
			return false;
		}

		if (spaceError) {
			this.messageService.showToaster('e_1', 'customizeLabels');
			return false;
		}

		return true;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/settings/customize-labels/customize-labels.ts